export const TopTypes = {
    MOST_ACTIVE: 'mostactive',
    GAINERS: 'gainers',
    LOSERS: 'losers'
}